import React, { useState, useEffect } from 'react';
import Loading from '../Loading'
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import { numberFormat } from '../Investor'




function HomeMobile(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus";
    const [pageData, setpageData] = useState({});
    const axiosPrivate = useAxiosPrivate();
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/super-investors?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;

        const cdresponse = await axiosPrivate.get(url);

        let tempData = cdresponse.data
        tempData.groups.forEach(item => (
            item.rows.sort(dynamicSortDescending("total_investments"))
        ))
        let finalData = JSON.parse(JSON.stringify(tempData))
        finalData.groups = []
        tempData.groups.forEach(item => {
            if (item.name === "Superinvestors") {
                finalData.groups.push(item)
            }
        })
        tempData.groups.forEach(item => {
            if (item.name === "Promoters") {
                finalData.groups.push(item)
            }
        })
        tempData.groups.forEach(item => {
            if (item.name === "Institutions Domestic") {
                finalData.groups.push(item)
            }
        })
        tempData.groups.forEach(item => {
            if (item.name === "Institutions Foreign") {
                finalData.groups.push(item)
            }
        })
        setpageData(finalData)

        /*let tempData = cdresponse.data
        tempData.groups.forEach(item => (
            item.rows.sort(dynamicSortDescending("total_investments"))
            ))
        setpageData(tempData)*/
    }
    const getUrl = (url) => {
        return "/Investor/" + url
    }
    const getCompanyUrl = (url) => {
        return "/CompanyInvestor/" + url
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            console.log(a[property])
            console.log(b[property])
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }

    useEffect(() => {
        companyDetails()
    }, [])


    return (
        <div className="HomeMobile" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "11px", minHeight: "650px", paddingLeft: "5px", paddingRight: "5px", paddingBottom: "110px", paddingTop: "10px" }}>

            <div>
                {Object.keys(pageData).length > 0 && pageData.groups.map(groupItem => (
                    <div style={{ padding: "10px 0px", whitespace: "nowrap"}}>

                        <div style={{ overflowX: "auto", backgroundColor: "white", borderRadius: "10px" }}>
                            <div className="AboutHeaderTop" style={{ paddingLeft: "0px", paddingTop: "0px" }}>
                                <div className="SuperHeader" style={{ textAlign: "left", padding: "10px 5px", fontSize: "11px", fontWeight: "600" }}>
                                    {groupItem.name}
                                </div>
                            </div>
                            <table className="PeersTable finData SupInvestorMobile" style={{ overflowX: "auto", fontSize: "9px", padding: "0px", whitespace: "nowrap"}}>
                                <tbody>
                                    <tr>
                                        <td className="columnHeading" style={{ textAlign: "left", fontWeight: "600", paddingLeft: "5px" }}>Superinvestors</td>
                                        <td className="columnHeading" style={{ textAlign: "center", fontWeight: "600", padding: "0px" }}>No of Stocks</td>
                                        <td className="columnHeading" style={{ textAlign: "center", fontWeight: "600", padding: "0px" }}>Inv Value</td>
                                        <td className="columnHeading" style={{ textAlign: "left", paddingLeft: "10px", fontWeight: "600", padding: "0px" }}>Top Holdings</td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    {groupItem.rows.map((dataKey, index) => (
                                        <tr>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "15px", textAlign: "left", minWidth: "0px", padding: "3px 10px", whiteSpace: "nowrap"}}><a href={getUrl(dataKey.id)} target="_blank" style={{ textDecoration: "none" }}>{dataKey.name}</a></td>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", textAlign: "center", minWidth: "0px", padding: "3px 10px", whiteSpace: "nowrap" }}>{dataKey.investments?.length}</td>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", textAlign: "center", minWidth: "0px", padding: "3px 5px 3px 0px", whiteSpace: "nowrap" }}>{numberFormat(dataKey.total_investments)}</td>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ textAlign: "left", paddingLeft: "30px", minWidth: "0px", padding: "3px 10px", whiteSpace: "nowrap", fontSize:"9px"}}>
                                                    
                                                    {dataKey.top_stocks?.map(data => (
                                                            <a href={getCompanyUrl(data)} target="_blank" style={{ textDecoration: "none" }}>{data} &nbsp; &nbsp;</a>
                                                    ))}

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>

                ))}
                {Object.keys(pageData).length === 0 &&
                    <div style={{ minHeight: "400px", paddingTop: "180px" }}>
                        <Loading />
                    </div>
                }

            </div>
        </div>
    );
}
export default HomeMobile;

